import React, { useState } from "react";
import { Badge, Card, Dropdown } from "react-bootstrap";
import { Plus, QuestionCircle, X } from "react-bootstrap-icons";

interface IProps {
  num: number;
  title: string;
  allItems: string[];
  selectedItems: string[];
  setItems: (items: string[]) => void;
}

const AddToggle = React.forwardRef<HTMLSpanElement, { onClick?: (e: React.MouseEvent) => void }>(
  ({ onClick }, ref) => (
    <Badge
      ref={ref}
      bg="primary"
      role="button"
      className="d-inline-flex align-items-center gap-1"
      style={{ cursor: "pointer", padding: "6px 10px" }}
      onClick={onClick}
    >
      <Plus size={13} />추가
    </Badge>
  )
);
AddToggle.displayName = "AddToggle";

const AccountBadgeCard = ({ num, title, allItems, selectedItems, setItems }: IProps) => {
  const remainingItems = allItems.filter((item) => !selectedItems.includes(item));

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header className="bg-white d-flex align-items-center gap-2">
        <Badge bg="primary" pill>{num}</Badge>
        <span className="fw-bold">{title}</span>
        <span className="flex-grow-1" />
        <Badge bg="light" text="dark">{selectedItems.length}개 적용</Badge>
      </Card.Header>
      <Card.Body className="d-flex flex-wrap gap-2 align-items-center">
        {selectedItems.map((item) => (
          <Badge
            key={item}
            bg="primary"
            role="button"
            className="d-inline-flex align-items-center gap-1 font-monospace"
            style={{ cursor: "pointer", padding: "6px 10px" }}
            onClick={() => setItems([...selectedItems.filter(i => i !== item)])}
            title="클릭: 제거"
          >
            {item}<X size={13} />
          </Badge>
        ))}
        {selectedItems.length === 0 && <span className="text-muted small">적용된 아이템이 없습니다.</span>}

        <Dropdown>
          <Dropdown.Toggle as={AddToggle} />
          {/* renderOnMount: 메뉴를 미리 마운트해 popper 인스턴스를 첫 오픈 전에 생성 → 첫 클릭 시 좌상단(0,0) 깜빡임 방지 */}
          <Dropdown.Menu renderOnMount popperConfig={{ strategy: "fixed" }}>
            {remainingItems.length === 0 && <Dropdown.ItemText className="text-muted small">모든 아이템 적용됨</Dropdown.ItemText>}
            {remainingItems.map((item) => (
              <Dropdown.Item key={item} className="font-monospace" onClick={() => setItems([...selectedItems, item])}>
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Body>
    </Card>
  );
};

export default AccountBadgeCard;
